import type { ReactNode } from 'react';

/**
 * Visual chrome that mirrors the mobile exam-taking screen's landscape
 * two-pane layout (apps/mobile MockTestScreen: qLeft/qRight + infoBar),
 * using the mobile app's actual theme colors (apps/mobile/src/theme —
 * warm brown/cream/orange, NOT the admin panel's own blue Tailwind
 * palette) so what the admin sees while authoring is a real preview of
 * what the exam will look like, not just a same-shaped form.
 */
export const MOBILE_COLORS = {
  cream: '#FFFDF5',
  infoBarBg: '#FFF9E8',
  border: '#F5E6D0',
  brown: '#2D2016',
  orange: '#FF8C42',
} as const;

interface ExamPreviewFrameProps {
  left: ReactNode;
  right: ReactNode;
  /** Rendered to the left of the "Submit" label, e.g. text-formatting buttons. */
  toolbar?: ReactNode;
}

export default function ExamPreviewFrame({ left, right, toolbar }: ExamPreviewFrameProps) {
  return (
    <div
      className="rounded-2xl overflow-hidden border"
      style={{ borderColor: MOBILE_COLORS.border }}
    >
      <div
        className="flex items-center justify-between gap-2 px-4 py-2 border-b"
        style={{ backgroundColor: MOBILE_COLORS.infoBarBg, borderColor: MOBILE_COLORS.border }}
      >
        <span className="text-xs font-bold shrink-0" style={{ color: MOBILE_COLORS.brown }}>
          Preview
        </span>
        <span className="text-xs font-semibold" style={{ color: MOBILE_COLORS.brown }}>
          How this question appears in the exam
        </span>
        <div className="flex items-center gap-2 shrink-0">
          {toolbar}
          <span className="text-xs font-bold" style={{ color: MOBILE_COLORS.orange }}>
            Submit
          </span>
        </div>
      </div>
      <div className="flex min-h-[360px]" style={{ backgroundColor: MOBILE_COLORS.cream }}>
        <div className="flex-1 border-r" style={{ borderColor: MOBILE_COLORS.border, padding: 18 }}>
          {left}
        </div>
        <div className="flex-1" style={{ padding: 14 }}>
          {right}
        </div>
      </div>
    </div>
  );
}
